import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {cityFilterState,kitsReady,rowsPerPageState,searchTextState,paginationState,productSelectForAction} from '../redux/kits'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productKits.css'

import {Cities} from './DropDowns/index'

import KitsCollapsibleRow from './KitsCollapsibleRow'

import * as Helpers from '../../../common/helpers'




import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

//import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterExportData (kitsData){
    let array = kitsData

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) { 

            if(array[i].kits.length>0){
            
                for (let j=0; j<array[i].kits.length; j++) {
                        let temp ={}

                        temp.id = array[i].id
                        temp.sku =  array[i].sku
                        temp.sku_name =  array[i].sku_name
                        temp.type =  array[i].type 
                        temp.category =    array[i].category         
                        temp.status =  array[i].status
                        temp.city =  array[i].city

                        temp.map_id=array[i].kits[j]['id']
                        temp.kit_id=array[i].kits[j]['kit_id']
                        temp.product_id=array[i].kits[j]['product_id']
                        temp.base_quantity=array[i].kits[j]['base_quantity']
                        temp.sequence=array[i].kits[j]['sequence']
                        temp.quantity=array[i].kits[j]['quantity']
                        temp.estimated_cost=array[i].kits[j]['estimated_cost']
                        temp.uom=array[i].kits[j]['uom']
                        temp.name=array[i].kits[j]['name']
                        temp.description=array[i].kits[j]['description']
                        newArray.push(temp)             
                    }   
            }else{
                newArray.push(array[i])
            }  
            
        }
    }
    return newArray
}

function filterUnwantedData(productListData) {
    let array = []
    
    if (productListData && productListData.data) {
        array = productListData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let lineData = array[i]
            let newLineData = {}

            

            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.sku = lineData.sku ? lineData.sku : ""
            newLineData.sku_name = lineData.name ? lineData.name : ""
            newLineData.type = lineData.type ? lineData.type : ""
            newLineData.category = lineData.category ? lineData.category : ""
            newLineData.status = lineData.status ? lineData.status : ""
            newLineData.city = lineData.city && lineData.city.name ? lineData.city.name : ""


            let kits = []
            for (let j = 0; j < lineData.kits.length; j++) {

                kits[j]={
                    "id":lineData.kits[j].id,
                    "kit_id":lineData.kits[j].kit_id,
                    "product_id":lineData.kits[j].product.id,
                    "base_quantity":lineData.kits[j].base_quantity,
                    "sequence":lineData.kits[j].sequence,
                    "quantity":lineData.kits[j].quantity,
                    "estimated_cost":lineData.kits[j].estimated_cost,
                    "uom":lineData.kits[j].uom,
                    "description":lineData.kits[j].description,
                    "name":lineData.kits[j].product.name
                }                    
            }   

            newLineData.products_count=kits.length
            newLineData.kits=kits;


            newArray[i] = newLineData
        }
    }
    return newArray
}

class KitsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            productsData: [],
            cityList:[],
            productSelected:{},
            citySelectedId:'',
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: "",
        }
        this.isComponentMounted = true
        this.cityComponent = null
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {


        this.isComponentMounted = true
        this.props.dispatch(kitsReady(false))
        this.props.dispatch(headerDataUpdate(Constants.KITS_TABLE))
        this.props.dispatch(subHeaderDataUpdate());

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
        //this.getProductsData()

        let previousCityId =0
        if(this.props.kits && this.props.kits.previousCity && this.props.kits.previousCity !== null){
            previousCityId = this.props.kits.previousCity
        }
        this.setState({
            citySelectedId: previousCityId
        }, () => {
            this.props.dispatch(cityFilterState(previousCityId))
            this.getProductsData()
        })
        
    }

    componentDidMount() {
    }


     createCSVData(csvData) {
        let ticketList = []
        if (csvData) {
            ticketList = JSON.parse(JSON.stringify(csvData))
            ticketList = createXLSheetdata(ticketList)
        }
        this.CSVData = ticketList
    }



    cityChange = (data) => {
        this.setState({
            citySelectedId : data.value
        })
        this.props.dispatch(cityFilterState(data.value))
    }

    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }




    expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <KitsCollapsibleRow row={row} row_id={row_id} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }

    
    getProductsData = () => {
        let city = this.state.citySelectedId
        apiService.getProductsData(city)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
       
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.kits && this.props.kits.previousPaginationValue) {
                            pageNo = this.props.kits.previousPaginationValue
                        }

                        this.setState({
                            productsData: array,
                            page: pageNo,
                        })

                        let exportdata=filterExportData(array)
                        this.createCSVData(exportdata)


                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
            }
                this.props.dispatch(kitsReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitsReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            value = this.props.kits.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

    

   

    createCustomToolBar = props => {


        let kitsDataFilename = "ProductKitsData_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"


        // let startDate = "", endDate = "", start = "", end = "", label = ""

        // startDate = moment(this.state.startDate)
        // endDate = moment(this.state.endDate)

        // start = moment(startDate).format('DD-MM-YYYY')
        // end = moment(endDate).format('DD-MM-YYYY')

        // label = start + ' to ' + end;

        // if (start === end) {
        //     label = start
        // }



        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">

                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins" ref ={el =>this.cityComponent =el} >
                        <Cities cityChange={this.cityChange} selectedValue={this.state.citySelectedId}/>
                    </div>

                    
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredProductsList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>


                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={kitsDataFilename}>
                            Export
                        </CSVLink>
                        
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.productsData.length>=(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)-this.props.kits.previousRowsPerPageValue+1} to {this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue} of {this.state.productsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)-this.props.kits.previousRowsPerPageValue+1} to {this.state.productsData.length} of {this.state.productsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredProductsList = () => {
       
        this.props.dispatch(kitsReady(false))
        this.resetSearchAndPagination()
        this.getProductsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.setState({
            citySelectedId: 0
        }, () => {
            this.props.dispatch(cityFilterState(0))
            this.getProductsData()
            this.props.dispatch(kitsReady(false))
            this.props.dispatch(searchTextState(""))

            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")
        })
        
        
    }

    getOutletsCounts = (cell, row) => {
       let  Outlets_size=row.store_kits.length
       
        return (<div className="row">
            <div>{Outlets_size}</div>
        </div>)
    }


    updateLoationButtonsCreator = (cell, row) => {
       let updateLocationBtn="NA"

        updateLocationBtn=<button
            className="action-button"
            style={{marginBottom: "1px",background: "#625b5b"}}
            onClick={(e) => {
                e.preventDefault()
                this.updateLocationBtn(row)
            }}>
            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> View Stores
        </button>
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{updateLocationBtn}</div>
        </div>)
    }

    updateProductsBtn  = (row) => {

        if (row && row.id) {
            this.props.dispatch(productSelectForAction(row))
            this.props.history.push("/dashboard/kits/products/list")
        } else {
            this.dialog.show({
                title: "Product Id not found",
                body: 'Product id is not available, So not able edit order',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    updateLocationBtn = (row) => {

        if (row && row.id) {
            this.props.dispatch(productSelectForAction(row))
            this.props.history.push("/dashboard/kits/stores/list")
        } else {
            this.dialog.show({
                title: "Product Id not found",
                body: 'Product id is not available, So not able edit order',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kits && this.props.kits.previousPaginationValue
            && this.props.kits.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    

    render() {
        let sizeperPage = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            sizeperPage = this.props.kits.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onPageChange: this.onPageChange
        }
        return (
            <div className="product-kit-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.productsData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 30
                    }}
                   >
                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="sku"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        SKU No.
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="sku_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        SKU Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="type"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="category"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Category
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="city"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="products_count"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kits Count
                    </TableHeaderColumn>

                    
                   
                </BootstrapTable>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kits: state.kits
    }
}

export default connect(mapStateToProps)(withRouter(KitsTable))


// WEBPACK FOOTER //
// ./src/modules/Kits/Components/KitsTable.js